import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/fold2/BgImg02.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>Simplify Intricate Processes with Our App Solutions</h2>
            </div>
            <p>
              TekRevol, a leading mobile app development company in Ohio has
              specialized in simplifying complex business challenges, without
              compromising on crucial functionalities. Our strategic approach
              and innovative strategies have helped us transform business ideas
              into a user-friendly, and efficient mobile application. By
              integrating intuitive functionalities, we ensure a seamless user
              experience. Hire our professional mobile app developers in Ohio,
              and let them create a smoother and more accessible user
              experience.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
